module.exports = __webpack_public_path__ + "./kit/docs/img/icon-search-desktop.b2849c7bd5199e22a0acada8d4cab366.svg";